export default {
  feature: {
    project: false,
    tags: false,
    creditAlarm: false,
    budgetAlarm: false,
    costByRegion: false,
  },

  billing: {
    dataTransfer: {
      enabled: false,
    },
    costPivot: {
      enabled: false,
    },
    costTrend: {
      enabled: false,
    },
    costAllocationTags: {
      enabled: false,
    },
    alarm: {
      enabled: false,
    },
    invoice: {
      enabled: false,
    },
    usageDetail: {
      enabled: false,
    },
    summary: {
      enabled: false,
    },
    cdn: {
      enabled: false,
    },
    consolidated: {
      enabled: false,
    },
  },
};
